import {
	type GetAllAccountingProfilesQuery,
	type GetAllAccountingProfilesQueryVariables,
	useGetAllAccountingProfilesLazyQuery,
} from "@repo/server-api";

import { useAsyncSelectCursorPaginatedLazyQuery } from "./AsyncSelectCursorPaginatedLazyQuery";

import type { AsyncSelectSearchHook } from "../BoundAsyncSelect";
import type { IdWithName } from "@repo/shared/common";

export function useAsyncSelectAccountingProfileQuery(): AsyncSelectSearchHook<IdWithName> {
	const [fetchProfiles] = useGetAllAccountingProfilesLazyQuery();

	const buildVariables = (
		search: string,
		cursor: string | null,
	): GetAllAccountingProfilesQueryVariables => ({
		name: search || null,
		first: 20,
		after: cursor,
	});

	const extractItems = (data: GetAllAccountingProfilesQuery | undefined): IdWithName[] =>
		data?.allAccountingProfiles?.nodes?.map((n) => ({
			id: n.id,
			name: n.name,
		})) ?? [];

	const extractEndCursor = (data: GetAllAccountingProfilesQuery | undefined): string | null =>
		data?.allAccountingProfiles?.pageInfo?.endCursor ?? null;

	const extractHasNextPage = (data: GetAllAccountingProfilesQuery | undefined): boolean =>
		data?.allAccountingProfiles?.pageInfo?.hasNextPage ?? false;

	return useAsyncSelectCursorPaginatedLazyQuery<
		GetAllAccountingProfilesQueryVariables,
		GetAllAccountingProfilesQuery,
		IdWithName
	>(fetchProfiles, buildVariables, extractItems, extractEndCursor, extractHasNextPage);
}
